import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import { BrandBlackWhite } from "./form/buttons";
import { getUserInfo } from "./user";
import { imagesUrl } from "./utils";

interface ExamListProps {
  examFee: number;
  examId: number;
  examName: string;
  examStatus: string;
  percentCompleted: number;
  paid: boolean;
  previousExams?: [];
}

interface ExamsProps {
  exams: ExamListProps[] | null;
  startExam: (id: number) => void;
  continueExam: (id: number) => void;
  viewSnapshotResults?: (examId: number, snapshotID: number) => void;
  restartExam?: (id: number) => void;
}

const ExamList = ({
  exams,
  startExam,
  continueExam,
  viewSnapshotResults,
  restartExam,
}: ExamsProps) => {
  if (!exams) return <></>;

  const userInfo = getUserInfo();

  const renderPreviousExams = (previousExams: []) => {
    const sortedPreviousExams = [...previousExams].reverse();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return sortedPreviousExams.map((exam: any) => (
      <li>
        <button
          onClick={() =>
            viewSnapshotResults &&
            viewSnapshotResults(exam?.exam_id, exam?.id_satsh)
          }
        >
          Exam Completed on {exam.created_at}
        </button>
      </li>
    ));
  };

  const mappedResults = exams.map((exam) => {
    const val = exam.examStatus === "completed" ? 100 : exam.percentCompleted;
    let style = {
      // default new style
      textSize: "16px",
      textColor: "#000",
      backgroundColor: "#cc9900",
      trailColor: "#d9d9d9",
      pathColor: "#d9d9d9",
    };
    if (exam.examStatus === "completed") {
      style = {
        textSize: "16px",
        textColor: "#fff",
        backgroundColor: "#477729",
        trailColor: "#477729",
        pathColor: "#477729",
      };
    }
    if (exam.examStatus === "inProgress") {
      style = {
        textSize: "16px",
        textColor: "#000",
        backgroundColor: "#cc9900",
        trailColor: "#bad7a7",
        pathColor: "#477729",
      };
    }
    return (
      <div className="listItemHolder">
        <div
          className={[
            "listItem",
            exam.examStatus === "completed" ? "completed" : "",
          ].join(" ")}
          key={Math.random()}
        >
          <div className="itemMeta">
            <div className="donutHolder">
              <CircularProgressbarWithChildren
                value={val}
                maxValue={100}
                styles={buildStyles(style)}
                strokeWidth={12}
              >
                {exam.examStatus === "new" && (
                  <div
                    style={{ fontSize: 14, marginTop: -5, textAlign: "center" }}
                  >
                    <strong>
                      NOT
                      <br />
                      STARTED
                    </strong>
                  </div>
                )}
                {exam.examStatus === "inProgress" && (
                  <div
                    style={{ fontSize: 14, marginTop: -5, textAlign: "center" }}
                  >
                    <strong>{val}%</strong>
                    <br />
                    Complete
                  </div>
                )}
                {exam.examStatus === "completed" && (
                  <div
                    style={{
                      fontSize: 14,
                      marginTop: -5,
                      textAlign: "center",
                      color: "#fff",
                    }}
                  >
                    <strong>100%</strong>
                    <br />
                    Complete
                  </div>
                )}
              </CircularProgressbarWithChildren>
            </div>
            <div className="itemContent">
              <div className="itemHeadline">{exam.examName}</div>
              <p>
                {exam.examStatus === "new" && (
                  <>
                    <img src={`${imagesUrl}start.svg`} /> New
                  </>
                )}
                {exam.examStatus === "inProgress" && (
                  <>
                    <img src={`${imagesUrl}in_progress.svg`} /> In Progress
                  </>
                )}
                {exam.examStatus === "completed" && (
                  <>
                    <img src={`${imagesUrl}completed.svg`} /> Completed
                  </>
                )}
              </p>
            </div>
          </div>
          <div className="itemAction">
            {exam.examStatus === "new" && (
              <BrandBlackWhite onClick={() => startExam(exam.examId)}>
                {userInfo?.userType === 0 ||
                (userInfo?.userType === 1 && exam.paid)
                  ? "Start"
                  : "Purchase"}{" "}
                &gt;
              </BrandBlackWhite>
            )}
            {exam.examStatus === "inProgress" && (
              <BrandBlackWhite onClick={() => continueExam(exam.examId)}>
                Continue &gt;
              </BrandBlackWhite>
            )}
            {exam.examStatus === "completed" && (
              <BrandBlackWhite
                onClick={() => restartExam && restartExam(exam.examId)}
              >
                Retake Exam &gt;
              </BrandBlackWhite>
            )}
          </div>
        </div>
        {exam?.previousExams && exam?.previousExams.length > 0 && (
          <div className="previousExams">
            <p>Previous Completed Exams</p>
            <ul>{renderPreviousExams(exam?.previousExams)}</ul>
          </div>
        )}
      </div>
    );
  });

  return <>{mappedResults}</>;
};

export default ExamList;
